import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Post } from '../../web_api/api'
import Swal from 'sweetalert2'

export default function PromoCreate() {

    const [image, setImage] = useState([])
    console.log(image, 'hi')
    const [title, setTitle] = useState('')
    const [subTitle, setSubTitle] = useState('')
    const [description, setDescription] = useState('')


    const handleImageChange = (e) => {
        if (e.target.files) {
            setImage([...image, e.target.files[0]])
            console.log(e.target.files[0])
        }
    }
    const create = async () => {
        const formData = new FormData()
        formData.append('title', title)
        formData.append('sub_title', subTitle)
        formData.append('description', description)
        image.map((item) => (
            formData.append('promotions', item)
        ))

        if (!image[0]) {
            Swal.fire({
                title: 'Need Image!',
                text: 'Try again!',
                icon: 'error',
                // showCancelButton: true,

                showConfirmButton: false,
                timer: 2000
            })
        } else {
            const createTreatment = await Post('/promotion-pages', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            // console.log(createTreatment, 'createTreatment')
        }

    }

    return (
        <div>
            <div className='border-1 border-info rounded-1 border p-3 mt-2'>

                <div>
                    <label for='#tn'>Title </label>
                    <input type='text' id='tn' placeholder='Title' className='form-control' onChange={(e) => setTitle(e.target.value)} />
                </div>
                <div>
                    <label for='#tn'>Sub Title </label>
                    <input type='text' id='tn' placeholder='Sub Title' className='form-control' onChange={(e) => setSubTitle(e.target.value)} />
                </div>
                <div className=''>
                    <label for='#tn' className={!image[0] ? 'text-red' : ''}>Image </label>
                    <input type='file' id='tn' className='form-control' onChange={handleImageChange} />
                </div>
                <div>
                    <label for='#tn'>Description </label>
                    <textarea type='text' id='tn' placeholder='Write description ...' className='form-control' onChange={(e) => setDescription(e.target.value)} />
                </div>
                {/* <div className='border-2 border-dark w-75 h-25'></div> */}
            </div>

            {/* Footer Button */}
            <div className='mt-3 text-end '>
                <Link to='/website-dashboard' className='btn btn-sm btn-default text-red rounded-2  ' >Cancel</Link>
                <button className='btn btn-sm btn-success rounded-2 ml-2 ' onClick={create}>Create</button>
            </div>
        </div>
    )
}
